import axios from "axios";
import config from "../config";

// Create a separate axios instance for livestream API
const livestreamAxios = axios.create({
  baseURL: config.baseApi,
});

// Add request interceptor to include authorization token
livestreamAxios.interceptors.request.use((request) => {
  const carMeetStorageString = localStorage.getItem("social-storage");
  const carMeetStorage = JSON.parse(carMeetStorageString);
  
  if (carMeetStorage && carMeetStorage.token) {
    const token = carMeetStorage.token;
    request.headers.Authorization = `Bearer ${token}`;
  }
  
  return request;
});

// Add response interceptor for error handling
livestreamAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) {
        localStorage.removeItem("social-storage");
        localStorage.clear();
        window.location = "/";
      }
    }
    return Promise.reject(error);
  }
);

const getLivestreamRequests = async (body) => {
  const response = await livestreamAxios.post(
    `/admin/live-streaming/requests`,
    body
  );

  return response;
};

const manageLivestreamRequest = async (body) => {
  const response = await livestreamAxios.post(
    `/admin/live-streaming/manage`,
    body
  );

  return response;
};

const getLivestreamPackages = async (body) => {
  const response = await livestreamAxios.post(
    `/admin/live-streaming/packages/list`,
    body
  );

  return response;
};

const createLivestreamPackage = async (body) => {
  const response = await livestreamAxios.post(
    `/admin/live-streaming/packages/create`,
    body
  );

  return response;
};

const updateLivestreamPackage = async (body) => {
  const response = await livestreamAxios.post(
    `/admin/live-streaming/packages/update`,
    body
  );

  return response;
};

const deleteLivestreamPackage = async (body) => {
  const response = await livestreamAxios.post(
    `/admin/live-streaming/packages/delete`,
    body
  );

  return response;
};

const LivestreamService = {
  getLivestreamRequests,
  manageLivestreamRequest,
  getLivestreamPackages,
  createLivestreamPackage,
  updateLivestreamPackage,
  deleteLivestreamPackage,
};

export default LivestreamService;
